export default __webpack_public_path__ + "static/pc-carousel-08-adeed60abe1a09b12e32c007b4b3c78c.jpg";